import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseWidgetModule } from '@fuse/components';
import { SharedModule } from '@shared/shared.module';
import { ReleaseNotesDialogComponent } from './release-notes-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DirectivesModule } from '@shared/directives/directives.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { ReleaseNoteBodyComponent } from './release-note-body/release-note-body.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DateFnsModule } from 'ngx-date-fns';
import { TranslationModule } from '@core/translation/translation.module';

@NgModule({
    declarations: [
        ReleaseNotesDialogComponent,
        ReleaseNoteBodyComponent,
    ],
    imports: [
        FuseSharedModule,
        FuseWidgetModule,

        SharedModule,
        DragDropModule,
        DirectivesModule,
        MatToolbarModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        DateFnsModule,
        TranslationModule,
    ],
    exports: [
        ReleaseNotesDialogComponent
    ]
})
export class ReleaseNotesDialogModule {
}
